export { default } from './MultiCam';
